import React from "react";
import "./index.scss";
import { Button } from "shared";

type StoreActionsProps = {
  buttonData?: Array<any>;
  onClick: (btn: any) => void;
};

const StoreActions = ({ buttonData = [], onClick }: StoreActionsProps) => {
  const compare = (v1: any, v2: any) => {
    if (v1.order_sequence_number > v2.order_sequence_number) return 1;
    if (v1.order_sequence_number < v2.order_sequence_number) return -1;
    return 0;
  };
  return (
    <div className="store-actions__container">
      {buttonData.length > 0 &&
        buttonData.sort(compare).map((btn: any) => (
          <Button
            key={btn.code}
            type={btn.button_background_color || "primary"}
            label={btn.button_text || btn.name}
            positionIcon="right"
            onClick={() => {
              onClick(btn);
            }}
            icon={btn.button_icon || "arrow_forward_ios"}
            customClassName="site-detail__button"
          />
        ))}
    </div>
  );
};

export default StoreActions;
